/* DSG — round 2: cart page enhancements, quote list + submission, quick order lookup/add.
   Loaded only on the cart template and the two round-two pages (quote, quick-order) — see
   layout/theme.liquid. Depends on window.DSGUI and window.DSG.routes from dsg-global.js,
   which loads first (both are `defer` scripts, so execution order is guaranteed). */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = c => '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // ---------- cart page: "move to quote" (progressive enhancement over plain Remove link)
  function initCartMoveToQuote() {
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-move-quote]'); if (!b) return;
      const UI = window.DSGUI; if (!UI) return;
      UI.addQuoteLines([{ variantId: +b.dataset.variantId, sku: b.dataset.sku, title: b.dataset.title, price: +b.dataset.price, qty: +b.dataset.qty || 1 }]);
      UI.toast && UI.toast('Moved to quote', b.dataset.title || '');
      if (b.dataset.removeUrl) location.href = b.dataset.removeUrl;
    });
  }

  // ---------- quote page: render + edit the local list, wire it into the contact form
  function initQuotePage() {
    const table = $('[data-quote-table]'); if (!table) return;
    const rowsBody = $('[data-quote-rows]');
    const emptyMsg = $('[data-quote-empty]');
    const actions = $('[data-quote-actions]');
    const lineCountEl = $('[data-quote-line-count]');
    const estTotalEl = $('[data-quote-est-total]');
    const bodyField = $('[data-quote-body-field]');
    const UI = window.DSGUI;
    if (!UI) return;

    function render() {
      const lines = UI.store.get('quote', []);
      if (!lines.length) {
        table.hidden = true; if (actions) actions.hidden = true; if (emptyMsg) emptyMsg.hidden = false;
        rowsBody.innerHTML = '';
      } else {
        if (emptyMsg) emptyMsg.hidden = true; table.hidden = false; if (actions) actions.hidden = false;
        rowsBody.innerHTML = lines.map((l, i) => `
          <tr>
            <td>${esc(l.title || 'Item')}</td>
            <td class="t-small">${esc(l.sku || '—')}</td>
            <td><div class="qty" data-qty>
              <button type="button" data-quote-qty-step="-1" data-i="${i}" aria-label="Decrease quantity">−</button>
              <input type="number" min="1" value="${l.qty}" data-quote-qty-input data-i="${i}" aria-label="Quantity">
              <button type="button" data-quote-qty-step="1" data-i="${i}" aria-label="Increase quantity">+</button>
            </div></td>
            <td class="t-num">${l.price != null ? money(l.price) : '—'}</td>
            <td class="t-num">${l.price != null ? money(l.price * l.qty) : '—'}</td>
            <td><button class="btn btn--tertiary btn--sm" type="button" data-quote-remove data-i="${i}">Remove</button></td>
          </tr>`).join('');
        const n = lines.reduce((a, l) => a + (l.qty || 0), 0);
        if (lineCountEl) lineCountEl.textContent = n;
        if (estTotalEl) estTotalEl.textContent = money(lines.reduce((a, l) => a + ((l.price || 0) * (l.qty || 0)), 0));
      }
      if (bodyField) {
        bodyField.value = lines.length
          ? 'Quote list:\n' + lines.map(l => `- ${l.title || 'Item'} (SKU ${l.sku || 'n/a'}) × ${l.qty}`).join('\n')
          : 'Quote list is empty — no items were saved in this browser when the form was submitted.';
      }
    }

    rowsBody.addEventListener('click', e => {
      const rm = e.target.closest('[data-quote-remove]');
      if (rm) { const lines = UI.store.get('quote', []); lines.splice(+rm.dataset.i, 1); UI.store.set('quote', lines); UI.refreshQuote(); render(); return; }
      const step = e.target.closest('[data-quote-qty-step]');
      if (step) { const lines = UI.store.get('quote', []); const i = +step.dataset.i; if (!lines[i]) return; lines[i].qty = Math.max(1, (lines[i].qty || 1) + (+step.dataset.quoteQtyStep)); UI.store.set('quote', lines); UI.refreshQuote(); render(); }
    });
    rowsBody.addEventListener('change', e => {
      const inp = e.target.closest('[data-quote-qty-input]'); if (!inp) return;
      const lines = UI.store.get('quote', []); const i = +inp.dataset.i; if (!lines[i]) return;
      lines[i].qty = Math.max(1, parseInt(inp.value, 10) || 1); UI.store.set('quote', lines); UI.refreshQuote(); render();
    });
    const clearBtn = $('[data-quote-clear]');
    clearBtn && clearBtn.addEventListener('click', () => { UI.store.set('quote', []); UI.refreshQuote(); render(); });

    render();
  }

  // ---------- quick order: rows, paste parsing, lookup, bulk add
  function parsePasteLine(line) {
    const commaParts = line.split(',').map(s => s.trim()).filter(Boolean);
    const tokens = (commaParts.length > 1 ? commaParts : line.trim().split(/\s+/)).filter(Boolean);
    if (!tokens.length) return null;
    const last = tokens[tokens.length - 1];
    if (tokens.length > 1 && /^\d+$/.test(last)) return { sku: tokens.slice(0, -1).join(' '), qty: parseInt(last, 10) };
    return { sku: tokens.join(' '), qty: 1 };
  }

  function initQuickOrder() {
    const app = $('[data-qo-app]'); if (!app) return;
    app.hidden = false;
    const rowsBody = $('[data-qo-rows]');
    const template = $('[data-qo-row-template]');
    const R = (window.DSG && window.DSG.routes) || {};
    const UI = window.DSGUI;
    const addCartBtn = $('[data-qo-add-cart]'), addQuoteBtn = $('[data-qo-add-quote]');

    function addRow(sku, qty) {
      const frag = template.content.cloneNode(true);
      const tr = frag.querySelector('[data-qo-row]');
      if (sku) tr.querySelector('[data-qo-sku]').value = sku;
      if (qty) tr.querySelector('[data-qo-qty]').value = qty;
      rowsBody.appendChild(frag);
    }
    function ensureRows(n) { while (rowsBody.children.length < n) addRow(); }
    function removeEmptyRows() { $$('[data-qo-row]', rowsBody).forEach(r => { if (!r.querySelector('[data-qo-sku]').value.trim()) r.remove(); }); }
    function resolvedRows() { return $$('[data-qo-row]', rowsBody).filter(r => r.dataset.status === 'found' && r.qoResolved); }
    function updateBulkButtons() {
      const has = resolvedRows().length > 0;
      if (addCartBtn) addCartBtn.disabled = !has;
      if (addQuoteBtn) addQuoteBtn.disabled = !has;
    }

    ensureRows(4);

    const addRowBtn = $('[data-qo-add-row]');
    addRowBtn && addRowBtn.addEventListener('click', () => addRow());
    const clearBtn = $('[data-qo-clear]');
    clearBtn && clearBtn.addEventListener('click', () => { rowsBody.innerHTML = ''; ensureRows(4); updateBulkButtons(); });

    const pasteAddBtn = $('[data-qo-paste-add]');
    pasteAddBtn && pasteAddBtn.addEventListener('click', () => {
      const ta = $('[data-qo-paste]');
      const lines = ta.value.split('\n').map(l => l.trim()).filter(Boolean);
      if (!lines.length) return;
      removeEmptyRows();
      lines.forEach(line => { const p = parsePasteLine(line); if (p) addRow(p.sku, p.qty); });
      ta.value = '';
      if (!rowsBody.children.length) ensureRows(1);
      updateBulkButtons();
    });

    rowsBody.addEventListener('click', e => {
      const rm = e.target.closest('[data-qo-remove-row]');
      if (rm) { rm.closest('[data-qo-row]').remove(); if (!rowsBody.children.length) ensureRows(1); updateBulkButtons(); }
    });
    rowsBody.addEventListener('input', e => {
      if (!e.target.matches('[data-qo-sku]')) return;
      const row = e.target.closest('[data-qo-row]');
      row.dataset.status = 'pending'; row.qoResolved = null;
      row.querySelector('[data-qo-result]').textContent = 'Not looked up yet';
      updateBulkButtons();
    });

    async function fetchProductJson(url) {
      try {
        const r = await fetch(url.split('?')[0] + '.js');
        if (!r.ok) return null;
        return await r.json();
      } catch { return null; }
    }

    async function lookup(term) {
      // Predictive search finds candidate products but its JSON response carries no
      // variant-level detail (no id/sku/price per variant) — only enough to match on.
      // So: use it to find candidates, then fetch each candidate's real product JSON
      // (/products/{handle}.js) to resolve an actual variant to add to cart/quote.
      const searchUrl = `${R.predictive}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last&resources[options][fields]=variants.sku,title,vendor`;
      const sr = await fetch(searchUrl);
      if (!sr.ok) return null;
      const sj = await sr.json();
      const candidates = (sj.resources && sj.resources.results && sj.resources.results.products) || [];
      if (!candidates.length) return null;

      const fulls = await Promise.all(candidates.map(p => fetchProductJson(p.url)));
      // Prefer an exact SKU match, checked across every candidate.
      for (const full of fulls) {
        if (!full) continue;
        const exact = (full.variants || []).find(v => (v.sku || '').toLowerCase() === term.toLowerCase());
        if (exact) return { title: full.title, url: full.url, variantId: exact.id, sku: exact.sku, price: exact.price, available: exact.available };
      }
      // No exact SKU match anywhere — fall back to the top relevance match's best variant.
      const top = fulls.find(Boolean);
      if (!top) return null;
      const variant = (top.variants || []).find(v => v.available) || (top.variants || [])[0];
      if (!variant) return null;
      return { title: top.title, url: top.url, variantId: variant.id, sku: variant.sku, price: variant.price, available: variant.available };
    }

    const findBtn = $('[data-qo-find]');
    findBtn && findBtn.addEventListener('click', async () => {
      const rows = $$('[data-qo-row]', rowsBody);
      findBtn.disabled = true;
      await Promise.all(rows.map(async row => {
        const term = row.querySelector('[data-qo-sku]').value.trim();
        const resultCell = row.querySelector('[data-qo-result]');
        if (!term) { row.dataset.status = 'pending'; row.qoResolved = null; resultCell.textContent = 'Not looked up yet'; return; }
        resultCell.textContent = 'Looking up…';
        try {
          const found = await lookup(term);
          if (found) {
            row.dataset.status = 'found'; row.qoResolved = found;
            resultCell.innerHTML = `<a href="${esc(found.url)}">${esc(found.title)}</a> — ${money(found.price)}${!found.available ? ' <span class="t-small">(special order)</span>' : ''}`;
          } else {
            row.dataset.status = 'not-found'; row.qoResolved = null;
            resultCell.textContent = 'Not found — check the part number';
          }
        } catch {
          row.dataset.status = 'not-found'; row.qoResolved = null;
          resultCell.textContent = 'Lookup failed — try again';
        }
      }));
      findBtn.disabled = false;
      updateBulkButtons();
    });

    addCartBtn && addCartBtn.addEventListener('click', async () => {
      const rows = resolvedRows(); if (!rows.length) return;
      const items = rows.map(r => ({ id: r.qoResolved.variantId, quantity: Math.max(1, parseInt(r.querySelector('[data-qo-qty]').value, 10) || 1), properties: { _fulfillment: UI ? UI.store.get('fulfil', 'plainview') : 'plainview' } }));
      try {
        const res = await fetch(R.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
        if (!res.ok) throw new Error();
        UI && UI.refreshCart && UI.refreshCart();
        UI && UI.toast && UI.toast(`Added ${rows.length} item${rows.length > 1 ? 's' : ''} to cart`, '', { href: R.cart, label: 'View cart' });
      } catch { UI && UI.toast && UI.toast('Could not add items to cart', 'Please try again.'); }
    });

    addQuoteBtn && addQuoteBtn.addEventListener('click', () => {
      const rows = resolvedRows(); if (!rows.length || !UI) return;
      const lines = rows.map(r => ({ variantId: r.qoResolved.variantId, sku: r.qoResolved.sku, title: r.qoResolved.title, price: r.qoResolved.price, qty: Math.max(1, parseInt(r.querySelector('[data-qo-qty]').value, 10) || 1) }));
      UI.addQuoteLines(lines);
      UI.toast && UI.toast(`Added ${lines.length} item${lines.length > 1 ? 's' : ''} to quote`, '');
    });

    updateBulkButtons();
  }

  document.addEventListener('DOMContentLoaded', () => { initCartMoveToQuote(); initQuotePage(); initQuickOrder(); });
})();
